/* eslint-disable */

import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import MainLayout from "../components/MainLayout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import {Trash2, Plus} from "lucide-react";
import {Calendar} from "primereact/calendar";
import {toast} from "react-toastify";
import {useNavigate, useLocation} from "react-router-dom";
import {BreadCrumb} from "primereact/breadcrumb";
import {addLocale} from "primereact/api";
import moment from "moment";
import "moment/locale/uz";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {InputNumber} from "primereact/inputnumber";
import {getVipusks} from "../services/vipusk.service";
import {
	createInvoice,
	editInvoice,
	getLastInvoice,
	getNakladnoySerialsById,
} from "../services/invoice.service";

addLocale("uz");

const InvoiceCreationPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const inputRef = useRef(null);

	const stateInvoice = location.state?.invoice;
	const stateHistory = location.state?.history;

	const editData = useMemo(
		() => stateInvoice || JSON.parse(localStorage.getItem("invoice-edit")),
		[stateInvoice],
	);

	const [searchText, setSearchText] = useState("");
	const [date, setDate] = useState(new Date());
	const [vipusk, setVipusk] = useState([]);
	const [invoice, setInvoice] = useState([]);
	const [seh, setSeh] = useState();
	const [invoiceNumber, setInvoiceNumber] = useState();
	const [editingInvoice, setEditingInvoice] = useState(null);
	const [loading, setLoading] = useState(false);
	const [editLoading, setEditLoading] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [showDialog, setShowDialog] = useState(false);
	const [deleteRowData, setDeleteRowData] = useState(null);
	const [lastInvoiceId, setLastInvoiceId] = useState();

	// FIX: unique_id bo'yicha tracking (id emas)
	const [usedUniqueIds, setUsedUniqueIds] = useState(new Set());

	// Har bir unique_id uchun original (API dan kelgan) amount
	const [originalVipuskAmounts, setOriginalVipuskAmounts] = useState({});

	// Har bir unique_id uchun max amount (invoice + vipusk)
	const [uniqueMaxAmounts, setUniqueMaxAmounts] = useState({});

	// FIX: Invoice dan o'chirilgan lekin vipusk jadvalida yo'q elementlar
	const [returnedToVipusk, setReturnedToVipusk] = useState([]);

	// pagination
	const [first, setFirst] = useState(0);
	const [rows, setRows] = useState(20);
	const [totalRecords, setTotalRecords] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);

	// URL va localStorage ni yangilash
	useEffect(() => {
		if (editData) {
			window.history.replaceState(null, "", `/invoice/${editData.id}`);

			if (stateInvoice && !stateHistory) {
				localStorage.setItem("invoice-edit", JSON.stringify(stateInvoice));
			}
		}

		return () => {
			localStorage.removeItem("invoice-edit");
		};
	}, [editData, stateInvoice, stateHistory]);

	// editData o'zgarganda formani to'ldirish
	useEffect(() => {
		if (editData) {
			setInvoiceNumber(editData.doc_no);
			setDate(moment(editData.date).toDate());
			setEditingInvoice(editData);
			setLoading(true);
		} else {
			setEditingInvoice(null);
		}
	}, [editData]);

	// Asosiy ma'lumotlarni yuklash
	const fetchVipusk = useCallback(async () => {
		setLoading(true);
		setEditLoading(true);

		try {
			const sehId = sessionStorage.getItem("sehId");

			const [lastInvoice, vipuskRes] = await Promise.all([
				getLastInvoice(),
				getVipusks(currentPage),
			]);

			setLastInvoiceId(lastInvoice.data);
			setTotalRecords(vipuskRes.total);

			// Original vipusk amountlarini saqlash
			const origAmounts = {};
			vipuskRes.data.forEach((item) => {
				origAmounts[item.unique_id] =
					(origAmounts[item.unique_id] || 0) + item.amount;
			});
			setOriginalVipuskAmounts(origAmounts);

			let selectedInvoiceData = [];

			if (editData) {
				setSeh(editData.seh_id);
				const invoiceRes = await getNakladnoySerialsById(editData.id);

				// Invoice ma'lumotlarini unique_id bo'yicha birlashtirish
				const invoiceMap = {};
				if (!stateHistory) {
					invoiceRes.forEach((item) => {
						const correct = editData.nakladnoy_uniques.find(
							(u) => u.unique_id === item.unique_id,
						);
						const amount = correct?.amount ?? item.amount;

						if (invoiceMap[item.unique_id]) {
							invoiceMap[item.unique_id].amount += amount;
						} else {
							invoiceMap[item.unique_id] = {
								...item,
								amount: amount,
							};
						}
					});
				} else {
					invoiceRes.forEach((item) => {
						invoiceMap[item.unique_id] = item;
					});
				}

				selectedInvoiceData = Object.values(invoiceMap);

				// FIX: usedUniqueIds ni to'ldirish
				const usedIds = new Set(
					selectedInvoiceData.map((item) => item.unique_id),
				);
				setUsedUniqueIds(usedIds);

				// Har bir unique_id uchun max amountni hisoblash
				const maxAmounts = {};
				selectedInvoiceData.forEach((item) => {
					const vipuskAmount = origAmounts[item.unique_id] || 0;
					maxAmounts[item.unique_id] = item.amount + vipuskAmount;
				});
				setUniqueMaxAmounts(maxAmounts);

				setInvoiceNumber(editData.doc_no);

				// Edit boshlanganida returnedToVipusk ni tozalash
				setReturnedToVipusk([]);
			} else {
				setSeh(sehId);
				setDate(new Date());
				setInvoiceNumber(lastInvoice.data);
				setUsedUniqueIds(new Set());
				setUniqueMaxAmounts({});
				setReturnedToVipusk([]);
			}

			setVipusk(vipuskRes.data);
			setInvoice(selectedInvoiceData);
		} finally {
			setLoading(false);
		}
	}, [editData, currentPage]);

	// Sahifa o'zgarganda vipusklarni qayta yuklash
	const fetchVipuskByPage = useCallback(async () => {
		setLoading(true);
		try {
			const vipuskRes = await getVipusks(currentPage);
			setTotalRecords(vipuskRes.total);
			setVipusk(vipuskRes.data);

			// Original amountlarni yangilash
			const origAmounts = {...originalVipuskAmounts};
			vipuskRes.data.forEach((item) => {
				if (!(item.unique_id in origAmounts)) {
					origAmounts[item.unique_id] = item.amount;
				}
			});
			setOriginalVipuskAmounts(origAmounts);
		} finally {
			setLoading(false);
		}
	}, [currentPage, originalVipuskAmounts]);

	useEffect(() => {
		fetchVipusk();
	}, [editingInvoice]);

	useEffect(() => {
		if (editingInvoice !== null || currentPage >= 1) {
			fetchVipuskByPage();
		}
	}, [currentPage]);

	useEffect(() => {
		if (invoice.length > 0 || (!editingInvoice && vipusk.length > 0)) {
			setEditLoading(false);
		}
	}, [invoice, vipusk, editingInvoice]);

	// FIX: Invoice dagi amountlarni unique_id bo'yicha hisoblash
	const invoiceAmountsByUniqueId = useMemo(() => {
		const amounts = {};
		invoice.forEach((item) => {
			amounts[item.unique_id] = (amounts[item.unique_id] || 0) + item.amount;
		});
		return amounts;
	}, [invoice]);

	// FIX: Тайёр мебеллар uchun to'g'ri combined data
	const combinedVipusk = useMemo(() => {
		const result = [];
		const processedUniqueIds = new Set();

		// 1. Avval returnedToVipusk elementlarini qo'shish (boshida ko'rinishi uchun)
		returnedToVipusk.forEach((returnedItem) => {
			if (processedUniqueIds.has(returnedItem.unique_id)) return;

			const invoiceAmount =
				invoiceAmountsByUniqueId[returnedItem.unique_id] || 0;
			const maxAmount = uniqueMaxAmounts[returnedItem.unique_id];

			if (maxAmount !== undefined) {
				const availableAmount = maxAmount - invoiceAmount;
				if (availableAmount > 0) {
					processedUniqueIds.add(returnedItem.unique_id);
					result.push({
						...returnedItem,
						amount: availableAmount,
					});
				}
			}
		});

		// 2. Vipusk elementlarini qo'shish
		vipusk.forEach((vipuskItem) => {
			if (processedUniqueIds.has(vipuskItem.unique_id)) return;
			processedUniqueIds.add(vipuskItem.unique_id);

			const invoiceAmount = invoiceAmountsByUniqueId[vipuskItem.unique_id] || 0;
			const maxAmount = uniqueMaxAmounts[vipuskItem.unique_id];

			let availableAmount;
			if (maxAmount !== undefined) {
				// Edit rejimida: max - invoice = available
				availableAmount = maxAmount - invoiceAmount;
			} else {
				// Yangi yaratishda: original vipusk amount
				availableAmount = vipuskItem.amount;
			}

			if (availableAmount > 0) {
				result.push({
					...vipuskItem,
					amount: availableAmount,
				});
			}
		});

		// 3. Invoice da bor lekin vipusk da yo'q itemlar uchun (amount kamaytirilib, qaytarilsa)
		invoice.forEach((invoiceItem) => {
			if (processedUniqueIds.has(invoiceItem.unique_id)) return;

			const maxAmount = uniqueMaxAmounts[invoiceItem.unique_id];
			if (maxAmount !== undefined) {
				const invoiceAmount =
					invoiceAmountsByUniqueId[invoiceItem.unique_id] || 0;
				const availableAmount = maxAmount - invoiceAmount;

				if (availableAmount > 0) {
					processedUniqueIds.add(invoiceItem.unique_id);
					result.push({
						...invoiceItem,
						amount: availableAmount,
					});
				}
			}
		});

		return result;
	}, [
		vipusk,
		invoice,
		returnedToVipusk,
		invoiceAmountsByUniqueId,
		uniqueMaxAmounts,
	]);

	// Qidiruv natijasi
	const filteredData = useMemo(() => {
		if (!searchText.trim()) return combinedVipusk;

		return combinedVipusk.filter((item) =>
			item.unique?.name?.toLowerCase().includes(searchText.toLowerCase()),
		);
	}, [combinedVipusk, searchText]);

	const saveInvoice = async () => {
		if (isSaving) return;

		setIsSaving(true);
		try {
			const localDate = new Date(
				date.getFullYear(),
				date.getMonth(),
				date.getDate(),
				5,
				0,
				0,
			);
			const newFormattedDate = localDate.toLocaleDateString("ru-RU");

			const uniqueIds = invoice.map((item) => ({
				unique_id: item.unique_id,
				amount: item.amount,
			}));

			if (editingInvoice) {
				await editInvoice(editingInvoice.id, {
					date: newFormattedDate,
					nakladnoy_uniques: uniqueIds,
				});
				toast.success("Накладной янгиланди");
			} else {
				await createInvoice({
					doc_no: lastInvoiceId,
					date: newFormattedDate,
					nakladnoy_uniques: uniqueIds,
				});
				toast.success("Накладной яратилди");
			}

			navigate("/invoice");
		} catch (error) {
			toast.error("Хатолик юз берди");
		} finally {
			setIsSaving(false);
		}
	};

	const handleAddToInvoice = (rowData) => {
		// rowData.amount - combinedVipusk dan kelgan available amount
		const amountToAdd = rowData.amount;

		setInvoice((prevInvoice) => {
			const existingItem = prevInvoice.find(
				(item) => item.unique_id === rowData.unique_id,
			);

			if (existingItem) {
				// Mavjud bo'lsa - prevInvoice dan haqiqiy amountni olib qo'shish
				return prevInvoice.map((item) =>
					item.unique_id === rowData.unique_id ?
						{...item, amount: item.amount + amountToAdd}
					:	item,
				);
			}

			// Yangi element qo'shish
			return [...prevInvoice, {...rowData, amount: amountToAdd}];
		});

		// Max amountni yangilash - faqat birinchi marta qo'shilganda
		setUniqueMaxAmounts((prev) => {
			if (prev[rowData.unique_id] !== undefined) {
				return prev;
			}
			const currentInvoiceAmount =
				invoiceAmountsByUniqueId[rowData.unique_id] || 0;
			return {
				...prev,
				[rowData.unique_id]: currentInvoiceAmount + amountToAdd,
			};
		});

		setUsedUniqueIds((prev) => new Set([...prev, rowData.unique_id]));

		// FIX: returnedToVipusk dan o'chirish (agar u yerda bo'lsa)
		setReturnedToVipusk((prev) =>
			prev.filter((item) => item.unique_id !== rowData.unique_id),
		);
	};

	const handleRemoveFromInvoice = (rowData) => {
		setDeleteRowData(rowData);
		setShowDialog(true);
	};

	const confirmDelete = () => {
		if (!deleteRowData) return;

		// Invoice dan o'chirish
		setInvoice((prev) =>
			prev.filter((item) => item.unique_id !== deleteRowData.unique_id),
		);

		// FIX: Agar vipusk da yo'q bo'lsa, returnedToVipusk ga qo'shish
		const existsInVipusk = vipusk.some(
			(v) => v.unique_id === deleteRowData.unique_id,
		);

		if (!existsInVipusk) {
			setReturnedToVipusk((prev) => {
				// Agar allaqachon bor bo'lsa, qo'shmaslik
				const exists = prev.some(
					(item) => item.unique_id === deleteRowData.unique_id,
				);
				if (exists) return prev;
				return [...prev, deleteRowData];
			});
		}

		// usedUniqueIds dan o'chirish
		setUsedUniqueIds((prev) => {
			const newSet = new Set(prev);
			newSet.delete(deleteRowData.unique_id);
			return newSet;
		});

		setShowDialog(false);
		setDeleteRowData(null);
	};

	// Invoice dagi amount ni kamaytirish
	const handleDecreaseAmount = (rowData) => {
		if (rowData.amount <= 1) return;

		setInvoice((prev) =>
			prev.map((item) =>
				item.unique_id === rowData.unique_id ?
					{...item, amount: item.amount - 1}
				:	item,
			),
		);
	};

	// Invoice dagi amount ni ko'paytirish
	const handleIncreaseAmount = (rowData) => {
		const maxAmount = uniqueMaxAmounts[rowData.unique_id] || rowData.amount;
		const currentAmount = invoiceAmountsByUniqueId[rowData.unique_id] || 0;

		if (currentAmount >= maxAmount) return;

		setInvoice((prev) =>
			prev.map((item) =>
				item.unique_id === rowData.unique_id ?
					{...item, amount: item.amount + 1}
				:	item,
			),
		);
	};

	// InputNumber uchun amount o'zgartirish
	const handleAmountChange = (rowData, newValue) => {
		if (newValue === null || newValue === undefined) return;

		const maxAmount = uniqueMaxAmounts[rowData.unique_id] || rowData.amount;

		if (newValue < 1 || newValue > maxAmount) return;

		setInvoice((prev) =>
			prev.map((item) =>
				item.unique_id === rowData.unique_id ?
					{...item, amount: newValue}
				:	item,
			),
		);
	};

	const item = [
		{
			label: "Накладнойлар",
			template: () => (
				<span className="cursor-pointer" onClick={() => navigate("/invoice")}>
					Накладнойлар
				</span>
			),
		},
		{
			label: "Nakladnoy tahrirlash",
			template: () => (
				<span className="font-semibold cursor-pointer text-primary">
					Накладной таҳрирлаш
				</span>
			),
		},
	];

	const item2 = [
		{
			label: "Накладнойлар",
			template: () => (
				<span className="cursor-pointer" onClick={() => navigate("/invoice")}>
					Накладнойлар
				</span>
			),
		},
		{
			label: "Nakladnoy tahrirlash",
			template: () => (
				<span className="font-semibold cursor-pointer text-primary">
					Накладной қўшиш
				</span>
			),
		},
	];

	const item3 = [
		{
			label: "Кабул килинган накладнойлар",
			template: () => (
				<span
					className="cursor-pointer"
					onClick={() => navigate("/invoice-history")}>
					Кабул килинган накладнойлар
				</span>
			),
		},
		{
			label: "Накладной маълумоти",
			template: () => (
				<span className="font-semibold cursor-pointer text-primary">
					Накладной маълумоти
				</span>
			),
		},
	];

	const onPage = (event) => {
		setFirst(event.first);
		setRows(event.rows);
		setCurrentPage(event.page + 1);
	};

	return (
		<MainLayout
			header={
				stateHistory ? `Накладной маълумоти`
				: editData ?
					`Накладной таҳрирлаш`
				:	`Накладной яратиш`
			}>
			<div>
				{stateHistory ?
					<BreadCrumb model={item3} className="px-0 pt-0 mb-6" />
				: editData ?
					<BreadCrumb model={item} className="px-0 pt-0 mb-6" />
				:	<BreadCrumb model={item2} className="px-0 pt-0 mb-6" />}
				<div className="p-6 px-0 pt-0">
					<div className="flex items-center gap-12">
						<div className="flex flex-col">
							<label className="mb-1 text-sm font-medium text-gray-700">
								Накладной рақами
							</label>
							<InputText
								value={invoiceNumber || ""}
								className="px-4 py-2 border"
								disabled
							/>
						</div>
						<div className="flex flex-col">
							<label className="mb-1 text-sm font-medium text-gray-700">
								Сех
							</label>
							<InputText
								value={seh || ""}
								className="px-4 py-2 border"
								disabled
							/>
						</div>
						<div className="flex flex-col">
							<label className="mb-1 text-sm font-medium text-gray-700">
								Накладной санаси
							</label>
							<Calendar
								disabled={stateHistory}
								inputRef={inputRef}
								value={date}
								onChange={(e) => {
									setDate(e.value);
								}}
								locale="uz"
								dateFormat="dd MM yy"
								className="px-4 py-2 border"
								onSelect={() => {
									setTimeout(() => inputRef.current?.blur(), 125);
								}}
							/>
						</div>
						{!stateHistory && (
							<div className="pt-6">
								<button
									disabled={!invoice.length || isSaving}
									className={`px-4 py-2 text-white rounded-md ${
										invoice.length && !isSaving ?
											"bg-[#002A50] hover:bg-opacity-90"
										:	"bg-[#305274] cursor-not-allowed"
									}`}
									onClick={saveInvoice}>
									{isSaving ?
										"Сақланмоқда..."
									: editingInvoice ?
										"Янгилаш"
									:	"Накладной яратиш"}
								</button>
							</div>
						)}
					</div>
				</div>
				<p className="my-3 text-2xl font-medium text-gray-700">
					Накладной формаси
				</p>
				<DataTable
					className="custom-row-border"
					value={invoice}
					rows={10}
					rowsPerPageOptions={[10, 25, 50]}
					loading={editLoading}
					emptyMessage="Нет доступных вариантов">
					<Column
						field=""
						header="N"
						headerClassName="w-fit"
						body={(_, {rowIndex}) => rowIndex + 1}
					/>
					<Column field="unique.name" header="Уникал номер" />
					<Column
						field=""
						header="Клиент"
						body={(rowData) =>
							rowData.demand_furniture_id ?
								(rowData.demand_furniture ?? rowData.demandFurniture)?.demand
									?.customer?.name
							:	"Супермаркет"
						}
					/>
					<Column
						field=""
						header="Комплект"
						body={(rowData) =>
							rowData.demand_furniture_id ?
								`${rowData.furniture?.category?.name} ${rowData.furniture?.komplekt?.name}`
							:	"Супермаркет"
						}
					/>
					<Column field="furniture.name" header="Мебель" />
					<Column
						field="amount"
						header="Сони"
						body={(rowData) => {
							const maxAmount =
								uniqueMaxAmounts[rowData.unique_id] || rowData.amount;
							const currentInvoiceAmount =
								invoiceAmountsByUniqueId[rowData.unique_id] || 0;
							const canIncrease = currentInvoiceAmount < maxAmount;

							return stateHistory ?
									rowData.amount
								:	<div className="flex items-center gap-1">
										<button
											className={`flex items-center justify-center w-8 h-8 text-gray-600 bg-gray-100 border border-gray-300 rounded ${
												rowData.amount > 1 ?
													"hover:bg-gray-200"
												:	"opacity-50 cursor-not-allowed"
											}`}
											onClick={() => handleDecreaseAmount(rowData)}
											disabled={rowData.amount <= 1}>
											<i className="text-xs pi pi-minus" />
										</button>
										<InputNumber
											value={rowData.amount}
											onValueChange={(e) =>
												handleAmountChange(rowData, e.value)
											}
											min={1}
											max={maxAmount}
											inputClassName="!w-12 text-center !outline-none !shadow-none"
											className="[&_input]:!outline-none [&_input]:!shadow-none"
										/>
										<button
											className={`flex items-center justify-center w-8 h-8 text-gray-600 bg-gray-100 border border-gray-300 rounded ${
												canIncrease ? "hover:bg-gray-200" : (
													"opacity-50 cursor-not-allowed"
												)
											}`}
											onClick={() => handleIncreaseAmount(rowData)}
											disabled={!canIncrease}>
											<i className="text-xs pi pi-plus" />
										</button>
									</div>;
						}}
					/>
					{!stateHistory && (
						<Column
							header="Ўчириш"
							body={(rowData) => (
								<Trash2
									className="cursor-pointer"
									onClick={() => handleRemoveFromInvoice(rowData)}
								/>
							)}
						/>
					)}
				</DataTable>

				{!stateHistory && (
					<>
						<p className="mt-12 text-2xl font-medium text-gray-700">
							Тайёр мебеллар
						</p>
						<div className="relative mt-2 mb-4">
							<i className="absolute text-gray-400 -translate-y-1/2 pointer-events-none pi pi-search left-3 top-1/2" />
							<InputText
								className="pl-9 pr-4 border h-[2.5em] max-[480px]:h-[2.5em] placeholder:leading-[normal] pt-[4px]"
								placeholder="Уникал номер"
								onChange={(e) => setSearchText(e.target.value)}
							/>
						</div>
						<DataTable
							className="custom-row-border"
							value={filteredData}
							lazy
							paginator
							rows={rows}
							totalRecords={
								totalRecords +
								returnedToVipusk.filter(
									(r) => !vipusk.some((v) => v.unique_id === r.unique_id),
								).length
							}
							first={first}
							onPage={onPage}
							loading={loading}
							emptyMessage="Нет доступных вариантов">
							<Column
								header="N"
								headerClassName="w-fit"
								body={(_, {rowIndex}) => first + rowIndex + 1}
							/>
							<Column field="unique.name" header="Уникал номер" />
							<Column
								header="Клиент"
								body={(rowData) =>
									rowData.demand_furniture_id ?
										rowData.demand_furniture.demand.customer.name
									:	"Супермаркет"
								}
							/>
							<Column
								header="Комплект"
								body={(rowData) =>
									rowData.demand_furniture_id ?
										`${rowData.furniture?.category?.name} ${rowData.furniture?.komplekt?.name}`
									:	"Супермаркет"
								}
							/>
							<Column
								field="furniture.name"
								header="Мебель"
								className="w-[300px]"
							/>
							<Column field="amount" header="Сони" className="w-[200px]" />
							<Column
								className="w-[220px]"
								header="Накладнойга қўшиш"
								body={(rowData) => (
									<Plus
										className="mx-auto border border-gray-500 rounded-[3px] text-gray-600 cursor-pointer"
										onClick={() => handleAddToInvoice(rowData)}
									/>
								)}
							/>
						</DataTable>
					</>
				)}
			</div>
			<Dialog
				visible={showDialog}
				onHide={() => setShowDialog(false)}
				header={
					<div className="text-lg font-semibold text-black">
						Серия рақамини ўчирмоқчимисиз?
					</div>
				}
				className="border-t-[6px] border-red-600 rounded-md shadow-lg"
				style={{width: "30rem"}}
				footer={
					<div className="flex justify-between mt-4">
						<Button
							label="Бекор килиш"
							icon="pi pi-times"
							className="px-4 py-2 text-black bg-gray-200 hover:bg-gray-300"
							onClick={() => setShowDialog(false)}
						/>
						<Button
							label="Ўчириш"
							icon="pi pi-trash"
							className="px-4 py-2 text-white bg-red-600 hover:bg-red-700"
							onClick={confirmDelete}
						/>
					</div>
				}
			/>
		</MainLayout>
	);
};

export default InvoiceCreationPage;
